module.exports = __webpack_public_path__ + "static/bett1aces-unboxing-49da2369988dfa4cd71e62764e0e51b9.mp4";